<template>
  <Modal title="予約確定" hideCloseButton @close="onClose">
    <p class="text">
      レスラクとの連携が<br v-if="!isSP" />
      「未連携」または<br v-if="isSP" />「一時停止」「停止」になっています。<br />
      媒体管理画面にて操作してください。<br /><br />台帳上での変更は可能ですが、<br />レスラク及び媒体へは連携されません。
    </p>
    <template #footer-center>
      <Button @click="onClose">戻る</Button>
      <StaffSelectPopover placement="top-end" @update:open="isShowStaffList = $event" @select="selectStaff">
        <Button caution :disabled="isShowStaffList">確定</Button>
      </StaffSelectPopover>
    </template>
  </Modal>
</template>

<script>
import Button from '@/components/atoms/Button'
import Modal from '@/components/molecules/Modal'
import StaffSelectPopover from '@/components/organisms/StaffSelectPopover'

export default {
  name: 'ResrakuSyncStatusVerifyModal',
  components: {
    Button,
    Modal,
    StaffSelectPopover,
  },
  props: {
    isSP: { type: Boolean, default: false },
  },
  data() {
    return {
      isShowStaffList: false,
    }
  },
  computed: {},
  methods: {
    onClose() {
      this.$emit('close')
    },
    selectStaff(staff) {
      this.$emit('confirm', staff)
      this.onClose()
    },
  },
}
</script>

<style lang="postcss" scoped>
.text {
  text-align: center;
}
</style>
